import { z } from 'zod';

/** 权限就两级，且与组织架构解耦——资产树不参与任何鉴权判断。 */
export const roleSchema = z.enum(['admin', 'member']);
export type Role = z.infer<typeof roleSchema>;

export const passwordSchema = z.string().min(12, '密码至少 12 位').max(200);

/** 6 位数字验证码，用于验证码登录和密码重置。 */
export const verificationCodeSchema = z.string().regex(/^\d{6}$/, '验证码是 6 位数字');

export const currentUserSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  role: roleSchema,
  /** 用一次性初始密码进来的人，首次登录后必须改密码。 */
  mustChangePassword: z.boolean(),
});

export type CurrentUser = z.infer<typeof currentUserSchema>;

export const passwordLoginSchema = z.object({
  email: z.string().trim().toLowerCase().email('请填写可用的邮箱地址'),
  password: z.string().min(1, '请填写密码'),
});

export const emailOnlySchema = z.object({
  email: z.string().trim().toLowerCase().email('请填写可用的邮箱地址'),
});

export const codeLoginSchema = z.object({
  email: z.string().trim().toLowerCase().email('请填写可用的邮箱地址'),
  code: verificationCodeSchema,
});

export const passwordResetSchema = z.object({
  email: z.string().trim().toLowerCase().email('请填写可用的邮箱地址'),
  code: verificationCodeSchema,
  password: passwordSchema,
});

/**
 * 请求验证码的响应。
 *
 * `delivered` 为 false 表示发信通道没配，前端要引导去「联系管理员重置」，
 * 而不是让用户在验证码框前干等。
 */
export const codeRequestResultSchema = z.object({
  delivered: z.boolean(),
  /** 邮箱掩码后的形式，让用户确认发到哪儿了，同时不泄露完整地址。 */
  maskedEmail: z.string().nullable(),
});

export type CodeRequestResult = z.infer<typeof codeRequestResultSchema>;

/** 探当前登录态：未登录不是错误，所以 user 可以为 null。 */
export const sessionProbeSchema = z.object({
  user: currentUserSchema.nullable(),
});

export const okSchema = z.object({ ok: z.literal(true) });

/** 邀请链接指向谁。姓名是管理员填的，接受邀请时显示出来让人确认没走错门。 */
export const inviteTargetSchema = z.object({
  email: z.string(),
  name: z.string(),
});

export const acceptInviteSchema = z.object({
  token: z.string().min(1),
  password: passwordSchema,
});

export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1, '请填写当前密码'),
  newPassword: passwordSchema,
});
